import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator,
    Platform,
    KeyboardAvoidingView,
    TouchableOpacity,
    Alert,
    BackHandler,
    StyleSheet,
    Button,
    Text,
    TextInput,
    I18nManager,
    Image
} from "react-native";
import stylesButton from "../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../customviews/empty/EmptyView";
import Colors from "../../../tools/Colors";
import DialogConnectionCustomize from "../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../customviews/HMActionBar";
import i18n from "../../../I18n/i18n";
import {typeExport} from "../../../redux/store/type";
import store from "../../../redux/store";
import {
    serviceActionAddSubList,
    serviceActionListFilter,
    serviceActionSuccess,
    serviceActionError,
    serviceActionAddMessage
} from "./action/ActionListMessageChatScreen";
import {moderateScale} from "../../../tools/Scaling";
import HMTextView from "../../../customviews/HMTextView";
import HMTextInput from "../../../customviews/HMTextInput";
//import HMModal from "../../../customviews/HMModal";
import * as NavigationService from "../../../redux/NavigationService";
import HMButton from "../../../customviews/HMButton";
import HMIcon from "../../../customviews/HMIcon";
import importFirebase from "../../../importCalss/firebase/importFirebase";


let container = null;

let firebase = importFirebase;

import autosize from "autosize";
import {
    serviceActionSetDisplayComment,
    serviceActionSetDisplayImage
} from "../../137/main/applay/action/ActionGalleryServiceOperationScreen";
import axios from "axios";
import Toast from "../../../customviews/toast";
import HMAlert from "../../../customviews/HMAlert";
import PathFile from "../../../assets/PathFile";
import moment from "moment-jalaali";
import {Tools} from "../../../tools/Tools";

moment.locale("fa");
let scrollNode = null;
export default class ListMessageChatScreen extends Component {
    constructor(props) {
        super(props);
        //global._refreshListOpertor = true;


        container = this;
        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 800 ? 2 : 1;

        }

        if (Platform.OS === "android") {

            //firebase = require("react-native-firebase")
            // alert(firebase)

        }

        let message = (props.route && props.route.params && props.route.params.extraData) ? props.route.params.extraData.sharing : ""
        this.state = {
            height: moderateScale(25),
            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            //  textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,


            /* dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                 name: 'در دست اقدام',
                 id: 2
             }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                 name: 'تایید واحد',
                 id: 5
             },],
             textCondition: null,
             arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                 name: 'تکراری در دست اقدام',
                 id: 3
             }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],*/
            Condition: {id: 0, value: "وضعیت پیام"},

            // arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            //   dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            trackingCode: null,

            massage: message

        };
        container = this;


        this.props.navigation.addListener('focus', () => {
                if (global._refreshListOpertor) {
                    store.dispatch(serviceActionListFilter([]))
                    props.callserviceActionRefresh();
                    this.getData(1)
                    global._refreshListOpertor = false
                }

            }
        )
        this.props.navigation.addListener('blur', () => {
            }
        )


    }

    /*    componentDidMount() {
            this._invertScrolling(true);
        }

        componentWillUnmount() {
            this._invertScrolling(false);
        }
    // in FlatList, add ref={ref => this._flatlistRef = ref}
        getScrollableNode = () => this._flatlistRef.getScrollableNode();

        _invertScrolling = (invert) => {
            this._scrollNode = this.getScrollableNode();
            if (invert) {
                this._scrollNode.addEventListener('wheel', this._invertedWheelEvent);
            } else {
                this._scrollNode.removeEventListener('wheel', this._invertedWheelEvent);
            }
        };

        _invertedWheelEvent = (e) => {
            if (this.props.horizontal) this._scrollNode.scrollLeft += (e.wheelDeltaX || -e.deltaX);
            else this._scrollNode.scrollTop += (e.wheelDeltaY || -e.deltaY);
            e.preventDefault();
        };*/
    state = {
        show: false
    };

    componentWillReceiveProps(props) {

        props.results && props.results.length > 0 && this.state.Once ?
            this.setState({
                    Once: false
                },
                () => {
                    if (firebase)
                        this.goDetailsOpenNotif()

                }
            )
            :
            null
    }

    /*    async componentDidMount() {

            const channel = new firebase.notifications.Android.Channel(
                'channelId',
                'Channel Name',
                firebase.notifications.Android.Importance.Max
            ).setDescription('A natural description of the channel');
            firebase.notifications().android.createChannel(channel);

            // the listener returns a function you can use to unsubscribe
            this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                if (Platform.OS === 'android') {
                    const localNotification = new firebase.notifications.Notification({
                        sound: 'default',
                        show_in_foreground: true,
                    }).setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .android.setChannelId('channelId') // e.g. the id you chose above
                        .android.setSmallIcon('logo') // create this icon in Android Studio
                        .android.setColor('#000000') // you can set a color here
                        .android.setPriority(firebase.notifications.Android.Priority.High);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));

                }
                else if (Platform.OS === 'ios') {

                    const localNotification = new firebase.notifications.Notification()
                        .setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .ios.setBadge(notification.ios.badge);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));
                }

                if (notification && notification.data && notification.data.typeOperation === '1') {
                    store.dispatch(serviceActionListFilter([]))
                    this.props.callserviceActionRefresh();
                    this.getData(1)
                }

            });
        }*/

    async componentDidMount() {
        if (Platform.OS === "web") {
    /*        scrollNode = this._flatlistRef && this._flatlistRef.getScrollableNode();
            if (!scrollNode) return;
            const listener = scrollNode.addEventListener("wheel", e => {
                scrollNode.scrollTop -= e.deltaY;
                e.preventDefault();
            });
            this._flatlistRef.setNativeProps({style: {transform: "translate3d(0,0,0) scaleY(-1)"}});*/


            this.textarea.focus();
            autosize(this.textarea);

            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 800 ? 2 : 1,
                    },
                )


            })


        }

        // await DeviceInfo.getMacAddress().then(mac => {
        //     //alert(mac)
        //     MAC_ADDRESS = mac
        // });
        store.dispatch(serviceActionListFilter([]))
        this.props.callserviceActionRefresh();
        this.getData(1)


        if (firebase) {
            const channel = new firebase.notifications.Android.Channel(
                '1',
                'A',
                firebase.notifications.Android.Importance.Max
            ).setDescription('A natural description of the channel');
            firebase.notifications().android.createChannel(channel);

            // the listener returns a function you can use to unsubscribe
            this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                //  alert("yyyy")
                if (Platform.OS === 'android') {
                    const localNotification = new firebase.notifications.Notification({
                        sound: 'default',
                        show_in_foreground: true,
                    }).setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .android.setChannelId('channelId') // e.g. the id you chose above
                        .android.setSmallIcon('logo') // create this icon in Android Studio
                        .android.setLargeIcon('logo') // create this icon in Android Studio

                        //  .android.setColor('#000000') // you can set a color here
                        .android.setPriority(firebase.notifications.Android.Priority.High);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error("error_notifications", err));

                }
                else if (Platform.OS === 'ios') {

                    const localNotification = new firebase.notifications.Notification()
                        .setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .ios.setBadge(notification.ios.badge);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));
                }


                if (notification && notification.data && notification.data.typeOperation === '1') {
                    if (item.length > 0) {
                        global.list_menu_shahrdar = item;
                        this.setState({alaki: !this.state.alaki})

                    }
                    store.dispatch(serviceActionListFilter([]))
                    this.props.callserviceActionRefresh();
                    this.getData(1)
                }

            });


            this.notificationOpenedListener = await firebase.notifications().onNotificationOpened((notificationOpen: NotificationOpen) => {
                // Get the action triggered by the notification being opened
                const action = notificationOpen.action;
                // Get information about the notification that was opened
                const notification: Notification = notificationOpen.notification;
                let item = null
                if (notificationOpen.notification.data.item)
                    item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())

                try {
                    firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)

                    switch (notificationOpen.notification.data.typeOperation) {
                        //looking for
                        case "1":
                            if (item) {
                                // if (this.props.result && this.props.result > 0) {
                                //     let idx = this.props.result.CartList.findIndex(obj => obj.RequestID === item.RequestID)
                                //     if (idx === -1) {
                                //         store.dispatch(serviceActionListFilter([]))
                                //         this.props.callserviceActionRefresh();
                                //         this.getData(1)
                                //     }
                                //
                                // }
                                //  NavigationService.navigateParams("DetailsOperatorApplyScreen", {item: item})

                                NavigationService.navigateParams("DetailsOperatorApplyScreen", {
                                    index: 0,
                                    item: item,
                                })
                            }

                            // NavigationService.navigatereset("MessagesBuy", {type: 1});
                            //NavigationService.navigateParams("MessagesBuy", {type: 2});
                            break;

                        // case "1":
                        //     // NavigationService.navigatereset("MessagesSell", {type: 2});
                        //     NavigationService.navigateParams("MessagesSell", {type: 1});
                        //     break;
                        default:

                    }

                }
                catch (e) {

                }

            });

        }


        // let myLocation = store.getState().reducerSplashGetAllData.Location;
        // myLocation ? this.sendLocation(myLocation.coords) : null;

    }

    async goDetailsOpenNotif() {
        const notificationOpen = await firebase.notifications().getInitialNotification();
        let item = null

        if (notificationOpen) {
            if (notificationOpen.notification.data.item)
                item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())
            firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)
            try {
                switch (notificationOpen.notification.data.typeOperation) {
                    //looking for
                    case "2":
                        if (item)
                            NavigationService.navigateParams("DetailsOperatorFireApplyScreen", {
                                index: 0,
                                item: item,
                            })
                        // NavigationService.navigatereset("MessagesBuy", {type: 1});
                        //     NavigationService.navigateParams("MessagesBuy", {type: 2});
                        break;

                    case "1":
                        // NavigationService.navigatereset("MessagesSell", {type: 2});
                        //NavigationService.navigateParams("MessagesSell", {type: 1});
                        break;
                    default:

                }

            }
            catch (e) {

            }
        }
    }

    componentWillUnmount() {

        // if (Platform.OS === 'web') {
        //     scrollNode.removeEventListener("wheel", listener);
        // }
         if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener();
            this.notificationOpenedListener();

        }
    }

    async getData(page) {
        let {item, data} = this.props.route.params

        let after = "0000-00-00";
        //   this.props.callService(urlListMessageChatScreen, `?type=${this.props.typee}&Condition=`, TypeGetListMessageChatScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListMessageChatScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListMessageChatScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListMessageChatScreen, _GET, page, 10)
  */

        let paramss = {
            "_operation": typeExport._Shahrdar,

            "mode": "RecievedMessage",
            "lang": i18n.locale,
            "_session": store.getState().reducerSplashGetAllData.token,
            "ID": item.ID,
            "page": page,
            //  "type": data.type,
            "listFilter": this.state.arraySelected,
            "trackingCode": this.state.trackingCode,

            //"token_fb": this.props.DataSplashScreen.token_fb,
        };
        if (store.getState().reducerSplashGetAllData.Connection) {

            this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetListMessageChatScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApply + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApplyFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };


    render() {
        let {item, data} = this.props.route.params

        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar

        // let childFilter = result.items[this.state.indexFilter].list;
        let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        return (
            <View style={{position: 'relative', flex: 1}}>

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar
                            // menu
                            props={this.props} statusBarTransparent
                            // text={i18n.t('ListOperatorApply.title')}
                            text={item.Name + " " + item.LastName}
                            //  text={moment(new Date()).format("jYYYY/jMM/jDD hh:mm:ss" )}
                            //   text={(data.name ? data.name : (data.title ? data.title : ''))}
                            //  text={this.state.arraySelected.length}

                            back
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />
                        {/*<TouchableOpacity
                            onPress={()=>{
                                store.dispatch(serviceActionAddSubList([{
                                    address:"aaaa",
                                    code: "_",
                                    color: "#ff0000",
                                    comment: [],
                                    createdtime: "19/8/8",
                                    image:null,
                                    video: null,
                                    latitude: '43.56564',
                                    longitude: "34.37546",
                                    status: i18n.t('constant.registrated'),
                                    title: "aaabbbb",
                                    subjectid: "111"
                                }, ...store.getState().reducerListMessageChatScreen.results]))
                            }}
                            style={{width:'100%',height:moderateScale(40)}}
                        />*/}
                        <View style={{flex: 1}}>
                            {/*   <View
                                style={{
                                    height: moderateScale(42),
                                    backgroundColor: Colors.colorPrimary,
                                    flexDirection: 'row',
                                    marginHorizontal: moderateScale(10),
                                    marginTop: moderateScale(6),
                                    borderRadius: moderateScale(14),
                                    borderColor: Colors.colorDark,
                                    borderWidth: moderateScale(1),
                                    //  marginBottom: moderateScale(10)
                                    // width:'100%'
                                }}>

                                <View
                                    style={{
                                        flex: .8,
                                        height: moderateScale(40),
                                        backgroundColor: Colors.white,
                                        borderRadius: moderateScale(14),
                                        flexDirection: 'row',
                                        paddingHorizontal: moderateScale(4),
                                        alignItems: 'center',

                                    }}>

                                    <View style={{width: moderateScale(5)}}/>

                                    <View style={{flex: 1, marginHorizontal: moderateScale(8)}}>
                                        <HMTextInput value={this.state.trackingCode}
                                                     onChangeText={(text) => this.setState({trackingCode: text}, () => {
                                                         //  this.getJsonMap()

                                                     })}
                                                     _height={40}
                                            //  autoFocus
                                            //  placeholder={i18n.t('constant.filter')}
                                                     placeholder={i18n.t('constant.TrackingCode')}
                                                     NoShowPlaceholder
                                            //باتد_width={'80%'}
                                            // icon={"md-person"}
                                                     style={{
                                                         fontSize: moderateScale(11),

                                                         // marginTop: moderateScale(6)
                                                     }} underlineColorAndroid="transparent"/>
                                    </View>
                                    {
                                    this.state.loadingAddressMarker ?
                                    <ActivityIndicator color={Colors.colorPrimary}
                                    size={"large"}/>

                                    :
                                    <HMTextView
                                    numberOfLines={1}
                                    onPress={() => HMAlert(
                                    i18n.t('constant.address'),
                                    this.state.addressMap,
                                    [
                                    // {text: 'Ask me later', onPress: () => {}},
                                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                    {
                                    text: i18n.t('constant.ok'), onPress: () => {
                                    }
                                    },
                                    ],
                                    {cancelable: true}
                                    )}
                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                    text={this.state.addressMap}
                                    type={"bold"} style={{
                                    //textAlign: "center",
                                    color: Colors.gray,
                                    fontSize: moderateScale(11),
                                    marginEnd: moderateScale(3)


                                    // flex:1
                                    }}/>
                                    }

                                </View>
                                <TouchableOpacity
                                    onPress={() => {
                                        this.getData(1)
                                        //  this.nextScreen(item, type)
                                    }}
                                    style={{
                                        flex: .2,
                                        height: moderateScale(32),
                                        backgroundColor: Colors.colorPrimary,
                                        borderTopEndRadius: moderateScale(14),
                                        borderBottomEndRadius: moderateScale(14),
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>

                                    <HMTextView
                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                        text={i18n.t('constant.Search')}
                                        type={"bold"}
                                        style={{
                                            textAlign: "center",
                                            color: Colors.white,
                                            fontSize: moderateScale(11)

                                        }}/>
                                </TouchableOpacity>

                            </View>*/}
                            <View style={{flex: 1}}>

                                <EmptyView empty={this.props.empty}/>
                                <FlatList
                                    ref={(ref) => this._flatlistRef = ref}
                                    data={this.props.results}
                                    inverted
                                    renderItem={({item, index}) => {

                                        let self = (item.Type == 1)


                                        return <View
                                            style={{
                                                flex: 1,
                                                alignItems: !self ? "flex-end" : "flex-start",
                                                justifyContent: !self ? "flex-end" : "flex-start",
                                                height: "auto",
                                                flexDirection: "row",
                                                marginRight: !self ? 10 : 0,
                                                //backgroundColor:"red"
                                            }}>

                                            <View
                                                style={[{
                                                    height: "auto",
                                                    maxWidth: "70%",
                                                    alignItems: !self ? "flex-end" : "flex-start",
                                                    padding: moderateScale(12),
                                                    marginLeft: moderateScale(7),
                                                    marginTop: moderateScale(10),
                                                    borderTopEndRadius: moderateScale(20),
                                                    borderTopLeftRadius: moderateScale(20),
                                                    borderBottomLeftRadius: moderateScale(20),
                                                    borderBottomRightRadius: moderateScale(20),
                                                }, {backgroundColor: self ? "#fff" : "#e3e3e3"}, self ? {
                                                    borderWidth: moderateScale(1),
                                                    borderColor: Colors.light43
                                                } : {}]}>
                                                {/*    {!self ? (
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        //text={item.ResDate}
                                                        text={"احمد خلیلی"}
                                                        //type={"bold"}
                                                        style={{
                                                            //  textAlign: "center",
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(14),


                                                        }}/>
                                                ) : null}*/}
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    //text={item.ResDate}
                                                    text={item.Message}
                                                    //type={"bold"}
                                                    style={{
                                                        //  textAlign: "center",
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(14),


                                                    }}
                                                    HyperlinkCheck={true}
                                                    linkStyle={{color: '#2980b9', fontSize: moderateScale(18)}}
                                                    onPressLink={(url, text) => Tools.GoLink(url)}
                                                    // linkText={ url => url === 'https://app.satia.co' ? 'app.satia.co' : url }
                                                />
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    //text={item.ResDate}
                                                    text={item.Jalali_DateTime}
                                                    //type={"bold"}
                                                    style={{
                                                        //  textAlign: "center",
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(14),


                                                    }}/>
                                            </View>
                                            {!self ? (
                                                <Image
                                                    source={item.Image && item.Image.length > 0 ? item.Image : (PathFile.image.user)}
                                                    //resizeMode="stretch"
                                                    style={[item.Image && item.Image.length > 0 ? {} : {tintColor: Colors.gray}, {
                                                        //   margin: moderateScale(5),
                                                        width: moderateScale(48),
                                                        height: moderateScale(48),
                                                        borderRadius: moderateScale(24),
                                                        marginHorizontal: moderateScale(6)

                                                        // tintColor: Colors.blackLight

                                                    }]}/>
                                                //  {/*<Avatar.Text style={styles.avatar} size={37} label={item.name.split('')[0]+item.name.split('')[1]} />*/}
                                            ) : null}
                                        </View>

                                    }} keyExtractor={(item, index) => index.toString()}
                                    ListEmptyComponent={() =>
                                        null}
                                    //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                    ListFooterComponent={this.renderFooter.bind(this)}
                                    refreshing={this.props.showRefresh}
                                    onRefresh={this.handleRefresh.bind(this)}
                                    onEndReached={this.handleLoadMore.bind(this)}
                                    initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                    onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}

                                    // initialScrollIndex={this.props.results ? this.props.results.length - 1 : 0}
                                    // onScrollToIndexFailed={info => {
                                    //     const wait = new Promise(resolve => setTimeout(resolve, 500));
                                    //     wait.then(() => {
                                    //         this.refFlatList?.scrollToIndex({index: info.index, animated: true});
                                    //     });
                                    // }}
                                    // numColumns={this.state.columnCount}
                                    // key={this.state.columnCount}
                                />
                            </View>
                            <View
                                style={[{
                                    position: "relative",
                                    height: "auto",
                                    minHeight: moderateScale(40),
                                    maxHeight: moderateScale(120),
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "row",
                                    borderTopWidth: 0.5,
                                    borderColor: '#b8b8b8',
                                    borderWidth: moderateScale(1),
                                    marginLeft: moderateScale(10),
                                    marginRight: moderateScale(10),
                                    marginBottom: moderateScale(10),
                                    borderRadius: moderateScale(14),
                                    overflow: "hidden",
                                    paddingHorizontal: moderateScale(8)

                                }]}>
                                {/*    <TouchableOpacity
                                    style={{
                                        width: moderateScale(28),
                                        height: moderateScale(28),
                                        alignItems: 'center', justifyContent: 'center',
                                        marginHorizontal: moderateScale(8)
                                    }}
                                    onPress={() => {
                                        // const formData = new FormData();
                                        // formData.append('lang', i18n.locale);
                                        // formData.append('record', item.id);
                                        // formData.append('recordChild', itemWork.id);
                                        // formData.append('_session', container.props.token);
                                        // formData.append('_operation', typeExport._Shahrdar);
                                        // // // formData.append('lang', params.lang);
                                        // formData.append('mode', "SetLikeComment");
                                        // store.dispatch(serviceActionSetDisplayComment(!itemWork.display, index, indexWork))
                                        //
                                        // this.setData(() => {
                                        // }, formData, index + "SetDisplayComment" + indexWork)
                                        //
                                    }}

                                >
                                    <HMIcon
                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                        name={"image-outline"}
                                        //resizeMode="stretch"
                                        style={[{fontSize: moderateScale(28)},
                                            {
                                                color: Colors.colorSecondPrimary
                                            }
                                        ]}/>
                                        {
                                                                        // this.state["isLoading" + index + "SetDisplayComment" + indexWork] ?
                                                                        //     <View style={{position: 'absolute',}}>
                                                                        //         <ActivityIndicator
                                                                        //             color={Colors.colorPrimary}
                                                                        //             size={"large"}/>
                                                                        //     </View>
                                                                        //     :
                                                                        //     null
                                                                    }
                                </TouchableOpacity>*/}
                                <View style={{flex: 1}}>
                                    {
                                        Platform.OS === "web" ?

                                            <textarea
                                                style={{
                                                    width: "100%",
                                                    paddingHorizontal: moderateScale(10),
                                                    outline: 'none',
                                                    maxHeight: "75px",
                                                    minHeight: "38px",
                                                    resize: "none",
                                                    padding: "9px",
                                                    boxSizing: "border-box",
                                                    fontSize: "15px",
                                                    border: '0 none ',
                                                    overflow: 'hidden',
                                                    backgroundColor: "transparent",
                                                    textAlign: I18nManager.isRTL ? 'right' : 'left',
                                                    fontFamily: typeExport.regularFontName,

                                                }}
                                                ref={c => (this.textarea = c)}
                                                placeholder="پیام ..."
                                                rows={1}
                                                defaultValue=""

                                                onChange={(event) => {
                                                    this.setState({massage: event.target.value});
                                                }}
                                                value={this.state.massage}
                                            />

                                            :
                                            <TextInput
                                                ref={c => (this.textarea = c)}
                                                onFocus={() => {
                                                    //   this.setState({inputhieght: {height: 58}});
                                                }}
                                                onBlur={() => {
                                                    //  setinputhieght({height: "11%"});
                                                    //  this.setState({inputhieght: {height: "11%"}});

                                                }}
                                                style={{
                                                    width: "100%",
                                                    //height: this.state.height,
                                                    //    height: "100%",
                                                    //position:'center',
                                                    maxHeight: moderateScale(75),
                                                    minHeight: moderateScale(38),
                                                    // backgroundColor: "#d105ee",
                                                    borderTopRightRadius: 0,
                                                    paddingHorizontal: moderateScale(10),
                                                    textAlign: I18nManager.isRTL && Platform.OS !== 'web' ? 'right' : 'left',
                                                    fontFamily: typeExport.regularFontName,

                                                    //paddingTop: 0,paddingBottom: 0,
//textAlign: "center"


                                                    // elevation :1
                                                }}
                                                multiline
                                                //   textAlign={'center'}
                                                placeholder="پیام ..."

                                                onChange={(event) => {

                                                }}
                                                onContentSizeChange={event => {
                                                    const {contentSize} = event.nativeEvent;
                                                    this.setState({
                                                        height: contentSize.height
                                                    });
                                                }}
                                                onChangeText={(msg) => {
                                                    this.setState({massage: msg});
                                                }}
                                                value={this.state.massage}
                                                theme={{

                                                    colors: {
                                                        primary: '#0084ff',
                                                    }
                                                }}
                                            />
                                    }
                                </View>
                                {
                                    this.state.massage && this.state.massage.trim().length > 0 ?
                                        <TouchableOpacity
                                            style={{
                                                width: moderateScale(28),
                                                height: moderateScale(28),
                                                alignItems: 'center', justifyContent: 'center',
                                                marginHorizontal: moderateScale(8)

                                            }}
                                            onPress={() => {
                                                const formData = new FormData();
                                                formData.append('lang', i18n.locale);
                                                formData.append('to', item.ID);
                                                formData.append('message', this.state.massage);
                                                formData.append('_session', store.getState().reducerSplashGetAllData.token);

                                                formData.append('_operation', typeExport._Shahrdar);
                                                // // formData.append('lang', params.lang);
                                                formData.append('mode', "SendMessage");
                                                store.dispatch(serviceActionAddMessage([{
                                                    Datetime: "May 16 2021  1:12PM",
                                                    ID: item.ID,
                                                    Jalali_DateTime: moment(new Date()).format("jYYYY/jMM/jDD hh:mm"),
                                                    Message: this.state.massage,
                                                    MessageID: 30,
                                                    Name: item.Name + " " + item.LastName,
                                                    Type: 1,
                                                }], this.props.page));
                                                this.setState({massage: ""})
                                                this.setData(() => {
                                                }, formData, "SendMessage")
                                            }}

                                        >

                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={"ارسال"}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.blue,
                                                    fontSize: moderateScale(13)

                                                }}/>
                                            {/*<HMIcon*/}
                                            {/*// source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}*/}
                                            {/*name={"eye-off"}*/}
                                            {/*//resizeMode="stretch"*/}
                                            {/*style={[{fontSize: moderateScale(28)},*/}
                                            {/*{*/}
                                            {/*color: Colors.colorSecondPrimary*/}
                                            {/*}*/}
                                            {/*]}/>*/}
                                            {/*    {
                                                                        this.state["isLoading" + index + "SetDisplayComment" + indexWork] ?
                                                                            <View style={{position: 'absolute',}}>
                                                                                <ActivityIndicator
                                                                                    color={Colors.colorPrimary}
                                                                                    size={"large"}/>
                                                                            </View>
                                                                            :
                                                                            null
                                                                    }*/}
                                        </TouchableOpacity>
                                        :
                                        null
                                }

                                {/*    <Button
                                    style={styles.send_btn}
                                    onPress={() => {
                                        // send();
                                    }}
                                    mode="text"
                                >{"dfgdfgfd"}
                                    <HMIcon name="paper-plane" size={25} color="#0084ff"/>
                                </Button>*/}
                            </View>
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }


                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    onTextChange(event) {
        const {contentSize, text} = event.nativeEvent;

        this.setState({
            message: text,
            height: contentSize.height > 100 ? 100 : contentSize.height
        });
    }

    checkSelect(item, index) {
        let l = container.state["selectFilter" + index];

        return l && l.id != 0
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.id !== 0
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.id !== 0
        //
        //     default:
        //
        // }
    }

    SelectNameFilter(item, index) {
        //let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar

        let l = this.state["selectFilter" + index]

        return l && l.value ? l.value : item.name
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.value
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.value
        //
        //     default:
        //
        // }
    }

    renderItemFilter = ({item, index}) => {
        let checkIndex = this.checkSelect(item, index);
        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar
        let idx = container.state.arraySelected.findIndex(obj => obj.index === index);

        return <View
            onPress={() => {

            }
            }
            style={{
                paddingHorizontal: moderateScale(3),
                backgroundColor: checkIndex ? Colors.colorPrimary : Colors.white,
                borderRadius: moderateScale(4),
                marginHorizontal: moderateScale(2)
            }}
        >
            {
                <View
                    style={[{
                        //marginVertical: moderateScale(15),
                        height: moderateScale(30),
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'row'
                    }]}>
                    {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                    {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                    {
                        checkIndex ?

                            <View style={{flexDirection: 'row'}}>


                                <TouchableOpacity
                                    onPress={() => {
                                        //  let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
                                        let arr = container.state.arraySelected;

                                        if (idx !== -1) {
                                            arr.splice(idx, 1)

                                            container.setState({
                                                    arraySelected: arr,
                                                    [`selectFilter${index}`]: {
                                                        value: item.name,
                                                        id: item.id,
                                                        type: item.type
                                                    },
                                                    visibleModal: '',
                                                },

                                                () => {
                                                    container.getData(1)
                                                }
                                            )
                                        }
                                        // container.setState({
                                        //         [`selectFilter${index}`]: {
                                        //             value: item.name,
                                        //             id: item.id,
                                        //             type:item.type
                                        //         },
                                        //         visibleModal: '',
                                        //     },
                                        //     () => {
                                        //         let arr = this.state.arraySelected;
                                        //         this.setState({
                                        //                 arraySelected: arr
                                        //             },
                                        //             () => {
                                        //                 container.getData(1)
                                        //             }
                                        //         )
                                        //
                                        //     }
                                        // )

                                    }}
                                    style={{
                                        alignSelf: 'center',
                                        //  marginHorizontal:moderateScale(6)
                                    }}>
                                    <HMIcon name={"md-close"} style={{
                                        fontSize: moderateScale(20),
                                        color: '#f2f2f2'
                                    }}/>

                                </TouchableOpacity>
                            </View>
                            :
                            null


                    }
                    {
                        checkIndex ?
                            <View style={{width: moderateScale(6),}}/>

                            :
                            null
                    }
                    <TouchableOpacity
                        onPress={() => {

                            this.setState({
                                    indexFilter: index,
                                    typeFilter: item.type,
                                    ["dataSource" + index]: item.list
                                },
                                () => {
                                    //  this.onShow(item.type == 2 ? 'Operational_Unit' : 'Condition')
                                    this.onShow('Modal')

                                })
                        }
                        }

                        style={{alignItems: 'center', flexDirection: 'row'}}
                    >

                        <HMTextView text={this.SelectNameFilter(item, index)} type={"bold"}
                                    style={{
                                        color: checkIndex ? Colors.white : Colors.gray,
                                        //marginHorizontal: moderateScale(6),
                                        fontSize: moderateScale(11),
                                        textAlign: 'center',

                                    }}/>
                        <HMIcon name={"ios-arrow-down"} style={{
                            fontSize: moderateScale(11),
                            color: checkIndex ? '#f2f2f2' : Colors.gray,
                            marginHorizontal: moderateScale(2),
                            marginTop: moderateScale(3)
                        }}/>
                    </TouchableOpacity>


                </View>

            }
            {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

        </View>
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashGetAllData.Connection) {
            this.getData(1)
        } else {
            // ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlListMessageChatScreen, `?type=${this.props.typee}&city=`, TypeGetListMessageChatScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={stylesButton.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {

        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashGetAllData.Connection) {
            // this.props.callService(urlListMessageChatScreen, `?type=${this.props.typee}&Condition=`, TypeGetListMessageChatScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }

    onChange(index, data) {

        let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
        let arr = container.state.arraySelected;

        if (idx !== -1) {
            arr.splice(idx, 1)

            container.setState({
                    arraySelected: arr
                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    container.state.arraySelected.push({
                        index: container.state.indexFilter,
                        data: data,
                        id: data.id,
                        value: data.name,
                        type: container.state.typeFilter
                    })
                }
            )

        } else {
            container.state.arraySelected.push({
                index: container.state.indexFilter,
                data: data,
                id: data.id,
                value: data.name,
                type: container.state.typeFilter
            })
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }

        let l = container.state.indexFilter

        container.setState({
                [`selectFilter${l}`]: {value: data.name, id: data.id, type: container.state.typeFilter},
                //indexFilterCondition: index,
                visibleModal: '',
            },
            () => {
                container.getData(1)
            }
        )
    }


    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }

    SearchFilterFunction(data, name, text, childFilter) {
        // let dataSource = "dataSource" + data
        // const newData = this.state[data].filter(function (item) {
        //     const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
        //     const textData = text.toUpperCase()
        //     return itemData.indexOf(textData) > -1
        // })
        // this.setState({
        //         [dataSource]: newData,
        //         //dataSource: newData,
        //         [name]: text
        //     },
        //     () => {
        //     })
        //

        let dataSource = "dataSource" + this.state.indexFilter;
        name = name + this.state.indexFilter;
        const newData = childFilter.list.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })
        this.setState({
                [dataSource]: newData,
                //dataSource: newData,
                [name]: text
            },
            () => {
            })
    }

    setData(func, formData, type) {

        let nameLoading = "isLoading" + type;
        let nameNoInternetDialog = "NoInternetDialog" + type;

        container.setState({
                //ShowImage:true
                [nameLoading]: true,
                [nameNoInternetDialog]: false,

            },

            () => {
            }
        )


        // const formData = new FormData();
        // formData.append('lang', i18n.locale);
        // formData.append('token', container.props.token);


        axios({
            method: 'post',
            url: typeExport._baseUrlSainaShahrdar,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;

                // data.status ? this.state.listImage.push(image) : null;

                if (data.success) {
                    func ? func(data.result) : null
                    // container.getDataServerSplash()
                }
                else {
                    Toast.show({
                        // type: 'success | error | info',
                        type: 'info',
                        //  position: 'top | bottom',
                        position: 'top',
                        text1: i18n.t('constant.message'),
                        text2: data.error && data.error.message ? data.error.message : data.message,
                        visibilityTime: 4000,
                        autoHide: true,
                        //  topOffset: 30,
                        // bottomOffset: 40,
                        onShow: () => {
                        },
                        onHide: () => {
                        }
                    })
                    // HMAlert(
                    //     i18n.t('constant.message'),
                    //     data.error &&  data.error.message?data.error.message:data.message,
                    //     [
                    //         {
                    //             text: i18n.t('constant.ok'), onPress: () => {
                    //
                    //             }
                    //
                    //
                    //         },
                    //
                    //     ],
                    //     {cancelable: true}
                    // )
                }
                container.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    [nameLoading]: false,
                    [nameNoInternetDialog]: !data.status,

                })
            }).catch((e) => {
            HMAlert(
                i18n.t('constant.message'),
                "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                [
                    {
                        text: i18n.t('constant.ok'), onPress: () => {

                        }


                    },

                ],
                {cancelable: true}
            )
            container.setState({
                //ShowImage:true
                [nameLoading]: false,
                [nameNoInternetDialog]: true,

            })
            console.log('error', e)
        })
    }
}

const styles = StyleSheet.create({
    flatlist: {
        height: "88.1%",
        // backgroundColor: "#f5f5f5",
        backgroundColor: 'white',
        paddingBottom: 10,
    },
    massageinput_container: {
        position: "relative",
        height: "auto",
        minHeight: moderateScale(60),
        maxHeight: moderateScale(120),
        alignContent: "center",
        justifyContent: "center",
        flexDirection: "row",
        borderTopWidth: 0.5,
        borderColor: '#b8b8b8'

    },
    send_btn: {
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        borderTopLeftRadius: 0,
    },
    massage_input: {
        width: "100%",
        backgroundColor: "white",
        borderTopRightRadius: 0,
        paddingHorizontal: moderateScale(10)

        // elevation :1
    },
    chatcontainer: {
        paddingBottom: 10,
        backgroundColor: 'white'

    },
    hry: {
        height: 110,
        flexDirection: "row",
    },
    avatar: {
        marginLeft: 10,
        marginTop: 10,
    },
    cha: {
        height: "auto",
        maxWidth: "70%",
        marginLeft: moderateScale(7),
        marginTop: moderateScale(10),
        padding: moderateScale(6),
        borderTopEndRadius: moderateScale(14),
        borderTopLeftRadius: moderateScale(14),
        borderBottomLeftRadius: moderateScale(14),
        borderBottomRightRadius: moderateScale(14),
    },
    id: {
        fontWeight: "bold",
        marginBottom: 3,
    },
    time: {
        alignSelf: "flex-end",
    },
});
